import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const VendorList = () => {
  const { state } = useLocation();
  const companyName = state?.companyName || '';
  const [allData, setAllData] = useState([]);
  const [SortKey, setSortKey] = useState('');
  const [SortOrder, setSortOrder] = useState('asc');
  const [searchKey, setSearchKey] = useState('');
  const [searchField, setSearchField] = useState('B2_CustomerCompany');
  const navigate = useNavigate();


  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch('https://43f7djf5c3.execute-api.ap-northeast-1.amazonaws.com/AdminTableStage/get_all_license');
      const data = await res.json();
      setAllData(data.Items || data);
    };

    fetchData();
  }, []);

  const handleSort = (key) => {
    if (SortKey === key) {
      setSortOrder(SortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
  };

  const getSortedData = (data, key, order) => {
    return [...data].sort((a, b) => {
      let valA = a[key] || '';
      let valB = b[key] || '';
      if (valA < valB) return order === 'asc' ? -1 : 1;
      if (valA > valB) return order === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const filteredData = getSortedData(
    allData.filter(d =>
      d.C1_OrderCompany === companyName &&
      (searchKey === '' || (d[searchField] || '').toString().includes(searchKey))
    ),
    SortKey,
    SortOrder
  );


  const renderArrow = (key) => {
    if (SortKey !== key) return '';
    return SortOrder === 'asc' ? ' ▲' : ' ▼';
  };

  const handleSendMail = async (item) => {
    try {
      const res = await fetch("https://i9i8zfsoai.execute-api.ap-northeast-1.amazonaws.com/DeliveryStage/send_mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });

      const data = await res.json();
      if (data.message === "success") {
        alert("納品メールを送信しました！");
        window.location.reload();
      } else {
        alert("送信に失敗しました：" + data.error);
      }
    } catch (err) {
      console.error("送信エラー:", err);
      alert("サーバーエラーが発生しました");
    }
  };

  return (
    <div className="container-list">
      <div className="header-fixed">

        <div className="home-button-wrapper">
          <button className="button button-red home-button" onClick={() => navigate('/license')}>
            <img src="/images/home_button_icon.png" className="home-icon" />
          </button>
        </div>
        <h1 className="title">申請一覧</h1>

        <div
          className="search-bar"
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px',
            marginTop: '-1.0em',
            marginBottom: '1.0em'
          }}
        >
          <select
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
            style={{ height: '24px', marginRight: '8px' }}
          >
            <option value="D1_SendMail">状態</option>
            <option value="D3_Trial">プラン</option>
            <option value="B1_CustomerType">形態</option>
            <option value="B2_CustomerCompany">エンドユーザー会社名</option>
            <option value="B3_CustomerPerson">エンドユーザー担当者名</option>
            <option value="B4_CustomerEmail">エンドユーザー担当者メール</option>
            <option value="A1_ProductName">製品名</option>
            <option value="A2_LicenseCount">個数</option>
            <option value="D5_UpdateVersion">ver.</option>
            <option value="A3_LicenseStartDate">開始日</option>
            <option value="A4_LicenseEndDate">終了日</option>
            <option value="CustomerEmail">ライセンスアドレス</option>
            <option value="LicenseKey">ライセンスキー</option>
            <option value="C2_OrderPerson">発注者名</option>
            <option value="C4_OrderNumber">弊社見積No.</option>
            <option value="C6_OrderID">発注番号</option>
            <option value="D2_RegisterDate">登録日</option>
          </select>

          <input
            type="text"
            placeholder="検索キーワード"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
          />

          <span style={{ marginLeft: '8px', whiteSpace: 'nowrap' }}>
            {searchKey ? `${filteredData.length} 件一致` : `${filteredData.length} 件全件表示`}
          </span>
        </div>
      </div>

      <div className="scroll-wrapper">
        <table className="orders-table">
          <thead>
            <tr className="orders-header-purple">
              <th>各種申請</th>
              <th onClick={() => handleSort('D1_SendMail')}>状態{renderArrow('D1_SendMail')}</th>
              <th onClick={() => handleSort('D3_Trial')}>プラン{renderArrow('D3_Trial')}</th>
              <th onClick={() => handleSort('B1_CustomerType')}>形態{renderArrow('B1_CustomerType')}</th>
              <th onClick={() => handleSort('B2_CustomerCompany')}>エンドユーザー会社名{renderArrow('B2_CustomerCompany')}</th>
              <th onClick={() => handleSort('B3_CustomerPerson')}>エンドユーザー担当者名{renderArrow('B3_CustomerPerson')}</th>
              <th onClick={() => handleSort('B4_CustomerEmail')}>エンドユーザー担当者メール{renderArrow('B4_CustomerEmail')}</th>
              <th onClick={() => handleSort('A1_ProductName')}>製品名{renderArrow('A1_ProductName')}</th>
              <th onClick={() => handleSort('A2_LicenseCount')}>個数{renderArrow('A2_LicenseCount')}</th>
              <th onClick={() => handleSort('D5_UpdateVersion')}>ver.{renderArrow('D5_UpdateVersion')}</th>
              <th onClick={() => handleSort('A3_LicenseStartDate')}>開始日{renderArrow('A3_LicenseStartDate')}</th>
              <th onClick={() => handleSort('A4_LicenseEndDate')}>終了日{renderArrow('A4_LicenseEndDate')}</th>
              <th onClick={() => handleSort('CustomerEmail')}>ライセンスアドレス{renderArrow('CustomerEmail')}</th>
              <th onClick={() => handleSort('LicenseKey')}>ライセンスキー{renderArrow('LicenseKey')}</th>
              <th onClick={() => handleSort('C2_OrderPerson')}>発注者名{renderArrow('C2_OrderPerson')}</th>
              <th onClick={() => handleSort('C4_OrderNumber')}>弊社見積No.{renderArrow('C4_OrderNumber')}</th>
              <th onClick={() => handleSort('C6_OrderID')}>発注番号{renderArrow('C6_OrderID')}</th>
              <th onClick={() => handleSort('D2_RegisterDate')}>登録日{renderArrow('D2_RegisterDate')}</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, idx) => (
              <tr key={idx}>
                <td><button
                  className="edit-button"
                  onClick={() => {
                    if (item.D1_SendMail === '納品待ち') {
                      alert('納品が完了するまでは変更はできません。');
                      return;
                    }
                    navigate('/license/edit', { state: { item } });
                  }}
                >
                  編集
                </button></td>
                <td>{item.D1_SendMail}</td>
                <td>{item.D3_Trial}</td>
                <td>{item.B1_CustomerType}</td>
                <td>{item.B2_CustomerCompany}</td>
                <td>{item.B3_CustomerPerson}</td>
                <td>{item.B4_CustomerEmail}</td>
                <td>{item.A1_ProductName}</td>
                <td>{item.A2_LicenseCount}</td>
                <td>{item.D5_UpdateVersion}</td>
                <td>{item.A3_LicenseStartDate}</td>
                <td>{item.A4_LicenseEndDate}</td>
                <td>{item.CustomerEmail}</td>
                <td>{item.LicenseKey}</td>
                <td>{item.C2_OrderPerson}</td>
                <td>{item.C4_OrderNumber}</td>
                <td>{item.C6_OrderID}</td>
                <td>{item.D2_RegisterDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VendorList;
